import { InvoiceSummaryStatsList } from 'components/Invoices/InvoiceSummaryStats/InvoiceSummaryStats'
import { useInvoiceSummaryStats } from 'components/Invoices/InvoiceSummaryStats/useInvoiceSummaryStats'
import { FC } from 'react'
import { useBillingScheduleId } from 'modules/BillingScheduleHome/utils/useBillingScheduleId'

export const ScheduleInvoiceSummaryStats: FC = () => {
  const billingScheduleId = useBillingScheduleId()
  const stats = useInvoiceSummaryStats(
    { billingScheduleId },
    'schedule.invoiceSummaryStats'
  )
  return (
    <InvoiceSummaryStatsList
      stats={stats}
      data-testid="schedule.invoiceSummaryStats"
    />
  )
}
